module.exports = __webpack_public_path__ + "img/pattern2.5fc536f4.png";